module.exports = __webpack_public_path__ + "static/media/sponsor.17b4fb48.webp";